import { render, staticRenderFns } from "./MainNavigationView.vue?vue&type=template&id=2c605107&scoped=true&"
import script from "./MainNavigationView.vue?vue&type=script&lang=ts&"
export * from "./MainNavigationView.vue?vue&type=script&lang=ts&"
import style0 from "./MainNavigationView.vue?vue&type=style&index=0&id=2c605107&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c605107",
  null
  
)

export default component.exports